export default "__VITE_ASSET__DVF0$rYW__"